import { getCurrentApiHost } from 'config/environment';
import { logger, ApiKey } from 'services';
const api_key = ApiKey.get();
export const cacheServiceWorker = async ()=>{
    if ('serviceWorker' in navigator) {
        try {
            var _worker_active;
            const worker = await navigator.serviceWorker.register('/cache-worker-v1.2.js');
            (_worker_active = worker.active) === null || _worker_active === void 0 ? void 0 : _worker_active.postMessage({
                host: getCurrentApiHost(),
                api_key
            });
        } catch (error) {
            logger.error('Service Worker registration failed', {
                error
            });
        }
    }
};
export const clearCache = ()=>caches.delete('rocketlane');
export const unregister = async (userId)=>{
    if ('serviceWorker' in navigator) {
        try {
            logger.log(`Proceeding to remove service Worker for user ${userId}`);
            const registration = await navigator.serviceWorker.ready;
            registration.unregister();
            logger.log(`Service Worker removed for user ${userId}`);
        } catch (error) {
            logger.error('Failed to remove service worker', {
                error
            });
        }
    }
};
